"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaConteudoMinistrado = exports.yupConteudoMinistrado = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupConteudoMinistrado = yup.object({
    idCurso: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Curso'),
    idSerie: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Serie'),
    idTurma: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Turma'),
    idMateria: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Materia'),
    idProfessor: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Professor'),
    bimestre: yup
        .number()
        .required()
        .positive()
        .label('Bimestre')
        .default(() => {
        let bimestre = 0;
        const mes = new Date().getMonth() + 1;
        if (mes <= 3)
            bimestre = 1;
        else if (mes <= 6)
            bimestre = 2;
        else if (mes <= 9)
            bimestre = 3;
        else
            bimestre = 4;
        return bimestre;
    }),
    data: (0, utils_1.sge2Date)().required().label('Data').default(''),
    conteudoMinistrado: yup.string().default('').required().max(8000).label('Conteúdo Ministrado'),
    gravarTodasTurmas: yup
        .boolean()
        .required()
        .default(false)
        .label('Gravar o Conteúdo Ministrado para todas as Turmas desta Série'),
    gravarIntervaloData: yup
        .boolean()
        .required()
        .default(false)
        .label('Gravar o Conteúdo Ministrado para um intervalo de datas'),
    dataFim: (0, utils_1.sge2Date)().label('Data Final').default(''),
});
exports.schemaConteudoMinistrado = exports.yupConteudoMinistrado.shape({});
